import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 7H10V33H18V7Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M30 7H22V33H30V7Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPlayerPause);
export { ForwardRef as ReactComponent };
